"use client";

import { useTranslations } from "next-intl";

const CAPABILITY_ROWS = [
	{
		labelKey: "weldingCapabilitiesRowWeldableMaterialsLabel",
		detailKey: "weldingCapabilitiesRowWeldableMaterialsDetail",
	},
	{
		labelKey: "weldingCapabilitiesRowPlateThicknessLabel",
		detailKey: "weldingCapabilitiesRowPlateThicknessDetail",
	},
	{
		labelKey: "weldingCapabilitiesRowWeldingPrecisionLabel",
		detailKey: "weldingCapabilitiesRowWeldingPrecisionDetail",
	},
	{
		labelKey: "weldingCapabilitiesRowQualityStandardsLabel",
		detailKey: "weldingCapabilitiesRowQualityStandardsDetail",
	},
	{
		labelKey: "weldingCapabilitiesRowProductionCapacityLabel",
		detailKey: "weldingCapabilitiesRowProductionCapacityDetail",
	},
	{
		labelKey: "weldingCapabilitiesRowServiceLeadTimeLabel",
		detailKey: "weldingCapabilitiesRowServiceLeadTimeDetail",
	},
] as const;

export default function MetalWeldingCapabilities() {
	const t = useTranslations("new-welding");

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 flex flex-col gap-4 sm:mb-8 md:mb-10 md:flex-row md:items-start md:justify-between md:gap-8 lg:mb-12 lg:gap-12">
					<h2 className="shrink-0 text-2xl font-bold leading-tight text-black sm:text-[30px] md:text-4xl">
						<span className="block">{t("weldingCapabilitiesTitleLine1")}</span>
						<span className="mt-1 inline-flex items-center gap-3">
							{t("weldingCapabilitiesTitleLine2")}
							<span className="inline-block h-1 w-20 self-end bg-themePrimary400" />
						</span>
					</h2>
					<p className="text-sm leading-relaxed text-black md:min-w-0 md:flex-1 md:text-base lg:max-w-[750px]">
						{t("weldingCapabilitiesDesc")}
					</p>
				</header>

				<div className="border-t border-[#ccccca]">
					<table className="w-full border-collapse text-left text-sm text-black md:text-base">
						<thead>
							<tr className="border-b border-[#ccccca]">
								<th scope="col" className="py-4 pl-6 font-bold sm:pl-8 md:pl-10">
									<div className="mx-auto lg:w-[300px]">{t("weldingCapabilitiesTableSpecHeader")}</div>
								</th>
								<th scope="col" className="py-4 font-bold">
									{t("weldingCapabilitiesTableDetailHeader")}
								</th>
							</tr>
						</thead>
						<tbody className="border-b border-[#ccccca]">
							{CAPABILITY_ROWS.map((row) => (
								<tr key={row.labelKey} className="border-b border-[#ccccca] last:border-b-0">
									<td className="py-4 pl-6 align-top font-bold sm:pl-8 md:pl-10">
										<div className="mx-auto lg:w-[300px]">{t(row.labelKey)}</div>
									</td>
									<td className="py-4 align-top font-normal">{t(row.detailKey)}</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			</div>
		</section>
	);
}
